<template>
  <div>{{ count }}/{{ max }}</div>
</template>

<script type="text/babel">
export default {
  props: {
    text: {
      required: true,
    },
    max: {
      type: [Number, String],
      required: false,
      default: 160,
    },
  },

  computed: {
    count() {
      return this.text ? this.text.length : 0;
    },
  },
};
</script>
